import { MagnifyingGlass } from '@phosphor-icons/react';
import { useRef } from 'react';
import { PRODUCT_SEARCH } from '@longjie/shared';
import { Button } from './components';
import { SearchClearButton } from './SearchClearButton';
import type { ProductSearchController } from './useProductSearch';
import './product-search.css';

/** Shared controls: extend this component to update every product search. */
export function ProductSearch({ search, ariaLabel = '搜索商品', disabled = false, busy = false,
  placeholder = PRODUCT_SEARCH.placeholder, buttonLabel = '搜索', className = '' }: {
  search: ProductSearchController;
  ariaLabel?: string;
  disabled?: boolean;
  busy?: boolean;
  placeholder?: string;
  buttonLabel?: string;
  className?: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  return <div className={`product-search ${className}`}>
    <div className="product-search__input">
      <MagnifyingGlass aria-hidden="true" />
      <input {...search.inputProps} ref={inputRef} className="search-clearable" type="search" autoComplete="off" aria-label={ariaLabel}
        placeholder={placeholder} disabled={disabled} />
      {search.input !== '' && <SearchClearButton label="清除商品搜索" disabled={disabled} onClear={() => {
        search.clear();
        inputRef.current?.focus({ preventScroll: true });
      }} />}
    </div>
    <Button type="button" variant="secondary" onClick={search.submit} disabled={disabled || busy || search.composing}>
      {buttonLabel}
    </Button>
  </div>;
}
